// extracted by mini-css-extract-plugin
export default {"zoomModal":"G1-z","image":"H1-z","button":"I1-z","isOverlayShown":"J1-z"};